import DirectionChiefItem from './direction-chief-Item'

export default DirectionChiefItem
